import * as React from "react";

import columnDefs from "./errandConfigListDefs";

import { constants } from "../../../store/buildings";
import BaseTable from "../../Lists/Base/FinalTable/BaseTable";
import { OPERATOR_TEMPLATES } from "../../Lists/Base/FinalTable/utils";

export default function BuildingErrandConfigTable({
  persistantQuery,
  tableId,
  ignoreLocalStorage,
  isBare,
  checkRowHighlighted,
  onRowClicked,
  onExcludeClicked,
}) {
  const columns = React.useMemo(
    () => columnDefs({ onExcludeClicked }),
    [persistantQuery, onExcludeClicked]
  );

  const filters = {
    Adress: {
      queryKey: "address__str_representation",
      type: "text",
      operators: OPERATOR_TEMPLATES.SEARCH,
    },
    Fastighet: {
      queryKey: "realestate__str_representation",
      type: "text",
      operators: OPERATOR_TEMPLATES.SEARCH,
    },
  };

  return (
    <BaseTable
      tableId={tableId || "buildings_errand_full_table"}
      title="Byggnader"
      onRowClickedWithDetail={(obj) => {}}
      {...{
        checkRowHighlighted,
        onRowClicked,
        ignoreLocalStorage,
        isBare,
        filters,
        constants,
        columns,
        persistantQuery,
      }}
    />
  );
}
